import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit", "submitText"]

  submitting() {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
      if (this.hasSubmitTextTarget) {
        this.submitTextTarget.textContent = "SUBMITTING..."
      }
    }
  }
}
